import React, { Component } from "react";
import PropTypes from 'prop-types';
import moment from 'moment';
import LinesEllipsis from 'react-lines-ellipsis'
import 'moment/locale/ru';

import "./MessageItem.scss";

import { getMsgTypeText } from "../../../../methods";

class MessageItem extends Component {
  static propTypes = {
    message: PropTypes.object.isRequired,
    onClickMessage: PropTypes.func.isRequired,
  };

  onClickMessageItem = id => {
    const { onClickMessage } = this.props;
    onClickMessage(id);
  }

  render() {
    const { message } = this.props;

    const typeText = getMsgTypeText(message.type);

    return (
      <div className="list-item-main" onClick={() => this.onClickMessageItem(message.id)}>
        <div className="list-item-title">
          <LinesEllipsis
            text={message.title}
            maxLine='2'
            ellipsis='...'
            trimRight
            basedOn='letters'
            className="title"
          />
        </div>
        <div className="list-item-content"> 
          <div className="msg-type-date">
            <div className="msg-type">{typeText}</div>
            <div className="msg-date">{moment(message.created_at).locale('ru').format('LL HH:mm')}</div>
          </div>
          <div className="list-item-for">
            {(message.role.findIndex(role => role === 'consultant') !== -1) ? 
              (<div className="for-item consultants">Консультанты</div>)
            : false}
            {(message.role.findIndex(role => role === 'client') !== -1) ? 
              (<div className="for-item clients">Клиенты</div>)
            : false}
          </div>
        </div>
      </div>
    );
  }
}

export default MessageItem;
